import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { s as styled } from './styled-112a8bd0.js';

const StyledCard = styled.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? 'padding: .5rem;' : ''}
`, space);
const CardHeader = styled.div ``;
const CardBody = styled.div ``;
const CardFooter = styled.div ``;
const Card = React.forwardRef((_a, ref) => {
    var { children, header, footer, withPadding } = _a, props = __rest(_a, ["children", "header", "footer", "withPadding"]);
    return (React.createElement(StyledCard, Object.assign({ ref: ref, withPadding: withPadding }, props),
        header && React.createElement(CardHeader, { className: "card-header" }, header),
        React.createElement(CardBody, { className: "card-body" }, children),
        footer && React.createElement(CardFooter, { className: "card-footer" }, footer)));
});
Card.displayName = 'Card';

export { Card as C };
